export default {
  en: {
    riskLedger: 'Risk Ledger',
    answerChangedGroup: '{name} changed the answer for {controls}',
    connectionComplianceChanged:
      'Overall compliance changed from {prevCompliancePercentage} to {newCompliancePercentage}',
    connectionComplianceNoChange: 'Overall compliance remains at {newCompliancePercentage}',
    answerChanged: '{name} changed {context} answer {prevValue} to {newValue}',
    answerChangedConnection:
      '{name} changed {context} answer {prevValue} to {newValue} for {control}',
    answerExpired: 'Answer has expired on {date}',
    answerExpiredConnection: 'Answer to {control} has expired on {date}',
    notesChanged: '{name} changed {context} answer notes',
    notesChangedConnection: '{name} changed {context} answer notes for {control}',
    evidenceAdded: '{name} added {fileName} as evidence',
    evidenceRemoved: '{name} removed {fileName} as evidence',
    evidenceRenamed: '{name} renamed {oldFileName} evidence to {newFileName}',
    evidenceAddedConnection: '{name} added {fileName} as evidence for {control}',
    evidenceRemovedConnection: '{name} removed {fileName} as evidence for {control}',
    evidenceReplaced: '{name} updated {fileName} evidence to a new version',
    evidenceReplacedConnection: '{name} updated {fileName} evidence to a new version for {control}',
    evidenceRenamedConnection:
      '{name} renamed {oldFileName} evidence to {newFileName} for {control}',
    policyRequirementChanged: 'Policy requirement changed from {prevValue} to {newValue}',
    policyRequirementChangedConnection:
      'Policy requirement changed from {prevValue} to {newValue} for {control}',
    policyRequirementChangedGroup:
      'Policy requirement changed for <b>{n} control</b> | Policy requirement changed for <b>{n} controls</b>',
    complianceChanged: 'Compliance changed from {prevCompliance} to {newCompliance}',
    complianceChangedConnection:
      'Compliance changed from {prevCompliance} to {newCompliance} for {control}',
    controlComplianceChangedGroup:
      'Compliance changed for <b>{n} control</b> | Compliance changed for <b>{n} controls</b>',
    overrideApplied: '{name} applied {overrideType} override',
    overrideRemoved: '{name} removed {overrideType} override',
    overrideAppliedGroup: '{name} applied {overrideType} to {controls}',
    overrideRemovedGroup: '{name} removed {overrideType} from {controls}',
    overrideAppliedConnection: '{name} applied {overrideType} override to {control}',
    overrideRemovedConnection: '{name} removed {overrideType} override from {control}',
    scopingAnswerChanged: '{name} changed {context} scoping answer {from} to {newValue}',
    scopingAnswerChangedConnection:
      '{name} changed {context} scoping answer to {newValue} for {domain}',
    scopingAnswerChangedGroup: '{name} changed the scoping answer for {domains}',
    domainScopingChanged: 'Control for {letter} became {newValue}',
    domainLetter: 'Domain {letter}',
    remediationRequested: '{name} requested a remediation',
    remediationResponded: '{name} responded to a remediation',
    remediationCancelled: '{name} cancelled a remediation',
    remediationCompleted: '{name} accepted a remediation',
    remediationRejected: '{name} rejected a remediation',
    remediationRequestedConnection: '{name} requested a remediation for {control}',
    remediationRespondedConnection: '{name} responded to a remediation for {control}',
    remediationCancelledConnection: '{name} cancelled a remediation for {control}',
    remediationCompletedConnection: '{name} accepted a remediation for {control}',
    remediationRejectedConnection: '{name} rejected a remediation for {control}',
    remediationRequestedGroup: '{name} requested the remediation of {control}',
    remediationCancelledGroup: '{name} cancelled the remediation of {control}',
    remediationRespondedGroup: '{name} responded to the remediation of {control}',
    remediationRejectedGroup: '{name} rejected the remediation of {control}',
    remediationCompletedGroup: '{name} accepted the remediation of {control}',
    remediationControlGroupCount: '{n} control | {n} controls',
    supplierAssessmentFrameworkUpdatedGroup: '{name} updated the supplier assessment framework',
    approvalStatusChanged: '{name} changed {context} status {prevStatus} to {newStatus}',
    pipelineStatusChanged: {
      set: '{name} set {context} pipeline status to {newStatus}',
      changed: '{name} changed {context} pipeline status from {prevStatus} to {newStatus}',
      label: {
        in_tender: 'in tender',
        pre_contract: 'pre-contract',
        in_contract: 'in contract',
        other: 'other',
      },
    },
    connectionCreated: 'Connection created between {client} and {supplier}',
    connectionRemoved: 'Connection removed between {client} and {supplier}',
    initialAssessmentCompleted: '{name} completed {context} assessment',
    reassessmentCompleted: '{name} completed {context} reassessment',
    clientAssessmentStarted: '{name} started a client-managed assessment of {supplier}',
    clientAssessmentCompleted: '{name} completed the client-managed assessment of {supplier}',
    connectionAnswerSetSwitched: {
      client: '{name} switched to the client-managed assessment',
      supplier: "{name} switched to {supplier}'s own assessment",
    },
    tagChanged: '{name} changed {context} {tagType} tag from {prevTag} to {newTag}',
    connectionHid: 'hid',
    connectionUnhid: 'unhid',
    connectionPrivacyChanged: '{name} {action} this supplier from the network',
    controlUpdateConfirmed: '{name} confirmed their answer after the control was updated',
    controlUpdateConfirmedConnection: '{name} confirmed their answer after {control} was updated',
    controlCreated: '{name} introduced a new {control}',
    controlModified: '{name} modified the question for {control}',
    controlDeprecated: '{name} deprecated {control}',
    reapprovalExpiryConnectionConfig: {
      full: '{name} changed the {reapproval} timeframe {prevApprovalExpiryPeriod} to {newApprovalExpiryPeriod}',
      prev: 'from {prevApprovalExpiryPeriod}',
      reapproval: 'Re-Approval',
      reapprovalTimeframe: '{value} {unit}',
      months: 'month | months',
      years: 'year | years',
      disabled: 'Disabled',
    },
    userAssignmentGroup: {
      singleAssignmentType: '{name} {assignmentType} {users}',
      multipleAssignmentType: '{name} assigned {assignedUsers} and unassigned {unassignedUsers}',
      noChangeType: 'User assignment remains the same',
      assigned: 'assigned',
      unassigned: 'unassigned',
      user: '{user}, ',
      beforeLastUser: '{user} ',
      lastUser: 'and {user}',
    },
    userAssigned: {
      other: '{name} assigned {assignee}',
      self: '{name} self-assigned this supplier',
    },
    userUnassigned: {
      other: '{name} unassigned {assignee}',
      self: '{name} removed their assignment',
    },
    reassessmentStarted: '{name} started {context} reassessment',
    labelAssigned: {
      labelExists: '{name} added the {label} label',
      labelMissing: '{name} added a label that has since been deleted',
    },
    labelUnassigned: {
      labelExists: '{name} removed the {label} label',
      labelMissing: '{name} removed a label that was later deleted',
    },
    labelAssignmentGroup: {
      onlyAssigned: {
        one: '{name} assigned the {assignedLabels} label',
        many: '{name} assigned the {assignedLabels} labels',
      },
      onlyUnassigned: {
        one: '{name} unassigned the {unassignedLabels} label',
        many: '{name} unassigned the {unassignedLabels} labels',
      },
      bothTypes:
        '{name} assigned the {assignedLabels} and unassigned the {unassignedLabels} labels',
      noChange: 'Label assignment remains the same',
      labelsMissing: '{name} changed labels that no longer exist',
    },
    approvalReviewerAdded: {
      other: '{name} added {reviewer} as an approver',
      self: '{name} added themselves as an approver',
    },
    approvalReviewerResponded: {
      approve: '{name} approved {supplier}',
      reject: '{name} rejected {supplier}',
    },
    approvalReviewerRemoved: {
      other: '{name} removed {reviewer} as an approver',
      self: '{name} removed themselves as an approver',
    },
    approvalReviewerAddedGroup: {
      message: '{name} added {reviewers} as approvers',
      separator: ', ',
      lastSeparator: ' and ',
    },
    approvalReviewerRemovedGroup: {
      message: '{name} removed {reviewers} as approvers',
      separator: ', ',
      lastSeparator: ' and ',
    },
    associatedRiskOpened: {
      forThis: '{name} opened {risk}',
      forAssociation: '{name} opened {risk} for {association}',
      friendlyID: 'Risk-{number}',
      control: 'Control {ref}',
    },
    associatedRiskClosed: {
      forThis: '{name} closed {risk}',
      forAssociation: '{name} closed {risk} for {association}',
      friendlyID: 'Risk-{number}',
      control: 'Control {ref}',
    },
    associatedRiskReopened: {
      forThis: '{name} re-opened {risk}',
      forAssociation: '{name} re-opened {risk} for {association}',
      friendlyID: 'Risk-{number}',
      control: 'Control {ref}',
    },
    associatedRiskDeleted: {
      forThis: '{name} deleted {risk}',
      forAssociation: '{name} deleted {risk} for {association}',
      friendlyID: 'Risk-{number}',
      control: 'Control {ref}',
    },
    scoping: {
      outOfScope: 'out of scope',
      inScope: 'in scope',
    },
    v2ComplianceReleased: {
      text: 'New compliance scoring rules were applied.',
      cta: 'Learn more',
    },
    v2ComplianceInitialScore: 'Overall compliance changed to {compliance}',
    context: {
      a: 'a',
      the: 'the',
      their: 'their',
      your: 'your',
      from: 'from',
      domainLetter: 'Domain {letter}',
    },
    answer: {
      no: 'No',
      yes: 'Yes',
      notRequired: 'Not required',
      orMore: '{0} or more',
      orLess: '{0} or less',
      unanswered: 'Unanswered',
    },
    control: 'Control {letter}',
    controls: '{n} control | {n} controls',
    domain: 'Domain {letter}',
    domains: '{n} domain | {n} domains',
    override: {
      exemption: 'an exemption',
      nonCompliance: 'a non-compliance',
      exemptions: 'exemption overrides',
      nonCompliances: 'non-compliance overrides',
    },
    seeMore: 'See more activities...',
    retry: 'Retry',
    failed: 'Failed fetching activity items',
    noneFound: 'No activity items found',
    empty: {
      title: 'No activity yet',
      description: 'Changes to this connection will appear here',
    },
    view: 'View',
    showMore: 'Show more',
    tag: {
      confidentiality: 'Confidentiality',
      criticality: 'Criticality',
      holdsPII: 'PII',
    },
    frameworkConfigConnectionChanged: {
      policyDriven: 'Policy-driven',
      level: {
        self: '{name} changed {supplier} framework level from {from} to {to}',
        other: '{name} changed your framework level from {from} to {to}',
      },
      addons: {
        selfAdditions: '{name} added {added} to {supplier} requirements',
        selfRemovals: '{name} removed {removed} from {supplier} requirements',
        selfAdditionAndRemovals:
          '{name} added {added} and removed {removed} from {supplier} requirements',
        otherAdditions: '{name} added {added} to your requirements',
        otherRemovals: '{name} removed {removed} from your requirements',
        otherAdditionAndRemovals:
          '{name} added {added} and removed {removed} from your requirements',
      },
    },
    userReviewedControl: '{name} marked this control as reviewed',
    userUnreviewedControl: '{name} marked this control as not reviewed',
  },
};
